import priceChangesAlertElementShown from '@hh.ru/analytics-js-events/build/xhh/employer/price/cart/price_changes_banner_element_shown';
import { Banner, Text } from '@hh.ru/magritte-ui';
import { TranslatedComponent } from 'bloko/common/hooks/useTranslations';
import { formatToReactComponent } from 'bloko/common/trl';

import ElementShownAnchor from 'src/components/ElementShownAnchor';
import HumanDate, { ShowYear } from 'src/components/HumanDate';
import translation from 'src/components/translation';
import useOnOffState from 'src/hooks/useOnOffState';
import { PriceChangeNotificationCartItem, PriceNotificationType } from 'src/models/price/priceCart';
import { REGULAR_SPACE } from 'src/utils/constants/symbols';

import PriceChangesAlert from 'src/components/Price/PriceCart/PriceCartFooter/PriceChangesBanner/PriceChangesAlert';
import ShowAlertButton from 'src/components/Price/PriceCart/PriceCartFooter/PriceChangesBanner/ShowAlertButton';

const TrlKeys = {
    content: {
        [PriceNotificationType.PriceChangeSoon]: 'price.cart.notifications.banner.price-change-soon.content',
        [PriceNotificationType.ProductCloseSoon]: 'price.cart.notifications.banner.product-close-soon.content',
        [PriceNotificationType.ProductCloseSoonPriceChangeSoon]:
            'price.cart.notifications.banner.price-change-product-close-soon.content',
    },
};

const PriceChangesBanner: TranslatedComponent<{
    notification: PriceChangeNotificationCartItem;
}> = ({ notification, trls }) => {
    const [visible, show, close] = useOnOffState(false);

    return (
        <>
            <ElementShownAnchor
                fn={priceChangesAlertElementShown}
                lastDateBeforeNewPrice={notification.params.lastDateBeforeNewPrice}
                reason={notification.type}
            >
                <Banner
                    content={
                        <>
                            <Text Element="span" typography="label-2-regular">
                                {formatToReactComponent(trls[TrlKeys.content[notification.type]], {
                                    '{0}': (
                                        <HumanDate
                                            date={notification.params.lastDateBeforeNewPrice}
                                            showYear={ShowYear.Never}
                                        />
                                    ),
                                })}
                            </Text>
                            {REGULAR_SPACE}
                            <ShowAlertButton onClick={show} />
                        </>
                    }
                    style="warning-secondary"
                    showClose={false}
                />
            </ElementShownAnchor>
            <PriceChangesAlert
                visible={visible}
                onClose={close}
                lastDateBeforeNewPrice={notification.params.lastDateBeforeNewPrice}
                newPriceDate={notification.params.newPriceDate}
                reason={notification.type}
            />
        </>
    );
};

export default translation(PriceChangesBanner);
